var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxLockStreamlineCore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Inbox-Lock--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Inbox Lock Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inbox-lock--mail-envelope-email-message-secure-password-lock-encryption"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M10.8911 0H1.57967C0.722579 0 0.027771 0.694808 0.027771 1.5519v0.07718L6.23535 4.73287l6.20765 -3.1038V1.5519C12.443 0.694808 11.7481 0 10.8911 0Zm1.5519 3.02661L6.51486 5.99066c-0.17595 0.08798 -0.38306 0.08798 -0.55901 0L0.027771 3.02662v4.73287c0 0.85709 0.694808 1.5519 1.551899 1.5519H6.0892c0.1143 -0.18327 0.25425 -0.34884 0.41479 -0.49176C6.59832 6.6942 8.35131 5 10.5 5c0.7051 0 1.3677 0.18246 1.943 0.50275V3.02661Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M9.25 9c0 -0.69036 0.55964 -1.25 1.25 -1.25 0.6904 0 1.25 0.55964 1.25 1.25v0.5h-2.5V9Zm-1.5 0.5315V9c0 -1.51878 1.23122 -2.75 2.75 -2.75 1.5188 0 2.75 1.23122 2.75 2.75v0.5315c0.4313 0.11102 0.75 0.5025 0.75 0.9685V13c0 0.5523 -0.4477 1 -1 1H8c-0.55228 0 -1 -0.4477 -1 -1v-2.5c0 -0.466 0.31869 -0.85748 0.75 -0.9685Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxLockStreamlineCore);
export default __webpack_public_path__ + "static/media/Inbox-Lock--Streamline-Core.d623688563122ea882d3412931d8f365.svg";
export { ForwardRef as ReactComponent };